// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"82cf828f","186":"8c754018","217":"1834b90a","253":"b546af9b","868":"5eeb6103","896":"63727f27","947":"49c9e7c5","972":"7299ac9a"}[chunkId] + ".chunk.js";
};